// material-ui
import { createTheme } from "@mui/material/styles";

const Palette = (mode) => {
  return createTheme({
    palette: {
      primary: {
        light: "#2558CD",
        main: "#2558CD",
        dark: "#2558CD",
        contrastText: "#ffffff",
      },
      black: {
        light: "#2E302E",
        main: "#2E302E",
        dark: "#2E302E",
        contrastText: "#2E302E",
      },
    },
  });
};

export default Palette;
